import {Directive, EventEmitter} from '@angular/core';
import {ToastController, Toast} from 'ionic-angular';

/**
 * Generated class for the ToastDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[toast]' // Attribute selector
})
export class ToastDirective {
  private toasts: Toast[] = [];
  closeEvent: EventEmitter<void> = new EventEmitter();
  constructor(
      public toastCtrl: ToastController,
  ) {}

  create(message, duration = 3000, type = 'error'): void {

      const toast = this.toastCtrl.create({
          message: message,
          duration: duration,
          cssClass: type,
          showCloseButton: true,
          closeButtonText: '×',
          position: 'bottom'
      });
      toast.present();
      this.toasts.push(toast);
  }

  createAdv(options): void {
      const defaults = {
          message: '',
          showCloseButton: true,
          closeButtonText: '×',
          position: 'bottom'
      };
      options = Object.assign(defaults, options);
      options.cssClass = options.type;
      const toast = this.toastCtrl.create(options);
      toast.present();
      if (defaults['closeButtonText'] && defaults['closeButtonText'] !== 'x') {
        toast.onDidDismiss(() => {
          this.closeEvent.emit();
        });
      }
      this.toasts.push(toast);
  }
  clearToasts(): void {
    this.toasts.forEach(t => {
      t.dismiss();
    });
    this.toasts = [];
  }
}



// WEBPACK FOOTER //
// ./src/shared/directives/toast/toast.ts